import React from 'react'

import Button, { ButtonProps } from './Button'

/**
 * セカンダリボタン
 */
const SecondaryButton: React.FC<ButtonProps> = (props) => (
  <Button
    {...props}
    color="var(--color-main)"
    background="var(--color-background)"
  />
)

export default SecondaryButton
